import axios from 'axios';

const SendgridApi = {
    async sendOffers( offers ) {
        const env = process.env.NODE_ENV !== 'development' ? 'Prod' : 'Dev'
        const response = await axios({
            method: 'post',
            url: `${ process.env.REACT_APP_OPS_UI_API_ENDPOINT }/${ env }/send-mail`,
            data: { request: `send_email`, data: offers }
        })
        return response;
    }
}

export default SendgridApi;